// Document statuses met hun waarden
export const DOCUMENT_STATUSES = {
  INTAKE: 'intake',
  TO_REVIEW: 'to_review',
  REVIEWED: 'reviewed',
  EXPORTED: 'exported',
};

// Labels voor de document statussen in de UI
export const DOCUMENT_STATUS_LABELS = {
  [DOCUMENT_STATUSES.INTAKE]: 'Intake',
  [DOCUMENT_STATUSES.TO_REVIEW]: 'Te Beoordelen',
  [DOCUMENT_STATUSES.REVIEWED]: 'Beoordeeld',
  [DOCUMENT_STATUSES.EXPORTED]: 'Geëxporteerd',
};

// Statuskleuren staan in het thema: palette.status.<status> (src/theme.js),
// bv. sx={{ bgcolor: 'status.intake' }}

// Gebruikersrollen
export const USER_ROLES = {
  ADMIN: 'admin',
  PROJECT_MANAGER: 'project_manager',
  USER: 'user',
};

// Storage configuratie
export const STORAGE = {
  BUCKET_NAME: 'project-documents', // Updated bucket name
  ALLOWED_TYPES: ['application/pdf', 'application/xml', 'text/xml', 'application/zip'],
  MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB
};

// Algemene validatie berichten
export const MESSAGES = {
  ERRORS: {
    FILE_TYPE: 'Alleen PDF, XML en ZIP bestanden zijn toegestaan',
    FILE_SIZE: 'Bestand is te groot (max 50MB)',
    UPLOAD_FAILED: 'Upload mislukt',
    NO_FILES: 'Geen bestanden geselecteerd',
    NO_PROJECT: 'Geen project geselecteerd',
  },
  SUCCESS: {
    UPLOAD: 'Document(en) succesvol geüpload',
    DELETE: 'Document succesvol verwijderd',
    STATUS_UPDATE: 'Status succesvol bijgewerkt',
  },
};
